import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=cc536052&scoped=true&"
import script from "./Dataset.vue?vue&type=script&lang=js&"
export * from "./Dataset.vue?vue&type=script&lang=js&"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=cc536052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc536052",
  null
  
)

component.options.__file = "Dataset.vue"
export default component.exports